import getStore from '../store';
import { computed } from 'mobx';

const computedIsMovingAssets = computed(() => {
    const { assetOffset } = getStore();
    return !!assetOffset && (!!assetOffset.dx || !!assetOffset.dy);
});

export default function isMovingAssets() {
    return computedIsMovingAssets.get();
}
